/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PostTrustedDeviceRequest = {
  platform: PostTrustedDeviceRequest.platform;
  nickname?: string | null;
  verification_key: string;
  /**
   * 0 이하 값은 무제한(영구)로 처리됩니다
   */
  expires_in_days?: number;
  user_agent?: string | null;
};

export namespace PostTrustedDeviceRequest {
  export enum platform {
    WEB = 'web',
    ANDROID = 'android',
    IOS = 'ios',
  }
}
